




















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Player } from '../models/simple-war';
import { getAgoTime } from '../utils/utilities';

@Component({
  components: {},
})
export default class PlayersListComponent extends Vue {
  @Prop() private players!: Player[];
  @Prop() private title!: string;
  @Prop() private subtitle!: string;
  @Prop() private emptyTitle!: string;
  @Prop() private emptySubtitle!: string;
  @Prop() private isFriends!: boolean;

  public inviteToGame(username: string, isAdvanced: boolean) {
    // console.log(`invite ${username} to new game, isAdvanced=${isAdvanced}`);
    this.$emit('inviteToGame', username, isAdvanced);
  }

  public getAgoTime(dateStr: string, currentStr: string) {
    return getAgoTime(dateStr, currentStr);
  }
}
